import { useEffect } from 'react';
import Swal from 'sweetalert2';

const Callback = ({ setCurrentPage }) => {
  useEffect(() => {
    // Get the parameters from URL query
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    const email = params.get('email');
    const name = params.get('name');
    const pathname = window.location.pathname;

    // Check if redirected to /loginerror path
    if (pathname.includes('/loginerror')) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Tutor Login',
        text: 'You are not a valid user. If error persists please contact admin.',
        confirmButtonColor: '#9b59b6',
        confirmButtonText: 'Go Back to Login',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        // Clear any stored data and clean URL, stay on login
        sessionStorage.removeItem('isLoggedIn');
        sessionStorage.removeItem('userEmail');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('loginTimestamp');
        window.history.pushState({}, document.title, window.location.pathname);
        setCurrentPage('login');
      });
    } else if (status === 'success' && email && name) {
      // Show success popup on login page
      Swal.fire({
        icon: 'success',
        title: 'Login Successful!',
        text: `Welcome ${name}!`,
        confirmButtonColor: '#9b59b6',
        confirmButtonText: 'Continue',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        // Store user data in sessionStorage
        sessionStorage.setItem('isLoggedIn', 'true');
        sessionStorage.setItem('userEmail', email);
        sessionStorage.setItem('userName', name);
        sessionStorage.setItem('loginTimestamp', new Date().getTime());
        
        // Clean URL and navigate to home
        window.history.pushState({}, document.title, window.location.pathname);
        setCurrentPage('home');
      });
    } else {
      // Handle unknown or missing parameters
      Swal.fire({
        icon: 'warning',
        title: 'Login Error',
        text: 'An unexpected error occurred. If error persists please contact admin.',
        confirmButtonColor: '#9b59b6',
        confirmButtonText: 'Go Back to Login',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
        setCurrentPage('login');
      });
    }
  }, [setCurrentPage]);

  // Show login page while processing callback
  return null;
};

export default Callback;
